import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { OnChange } from '@df/ng/on-change';
import { Subscription, merge } from 'rxjs';
import { Swiper } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
declare module 'swiper' {
    interface Swiper {
        snapIndex: number;
    }
}
@Component({
    selector: 'swiper-dots',
    templateUrl: './swiper-dots.component.html',
    styleUrls: ['./swiper-dots.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwiperDotsComponent implements AfterViewInit {
    @Input({
        required: true
    })
    @OnChange('update')
    swiperRef!: SwiperComponent;

    swiper?: Swiper;
    index = 0;

    private subscriptions = new Subscription();

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    ngAfterViewInit() {
        this.subscriptions.add(
            merge(this.swiperRef.s_swiper, this.swiperRef.s_slideChange, this.swiperRef.s_paginationUpdate).subscribe(() => this.update())
        );
        this.update();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    get bullets() {
        return (this.swiper?.pagination.bullets as unknown as Array<any>) || [];
    }
    slideTo(index = 0) {
        const swiper = this.swiperRef?.swiperRef;
        const slidesPerGroup = swiper?.params.slidesPerGroup || 1;
        const loop = swiper?.params.loop || false;
        let slideTo = index * slidesPerGroup;
        if (loop) {
            slideTo += swiper.loopedSlides || 0;
        }
        this.swiper?.slideTo(slideTo);
    }
    private update() {
        const slidesPerGroup = this.swiperRef?.slidesPerGroup || 1;
        this.swiper = this.swiperRef?.swiperRef;
        this.index = (slidesPerGroup > 1 ? this.swiper?.snapIndex : this.swiper?.realIndex) || 0;
        this.changeDetectorRef.detectChanges();
    }
}
